const encode = (str) => {
    var encode = encodeURI(str);
    var base64 = btoa(encode);
    return base64;
}

const handleDownloadUri = (title,  uri)  => {
    let ext = uri.substring(uri.lastIndexOf('.') + 1);
    title = title+'.'+ext

    if (uri.indexOf("https://") < 0) {
        uri = uri.replace("http://", "https://");
    }

    let elt = document.createElement('a');
    elt.setAttribute('href', uri+'?download_name='+title);
    elt.setAttribute('download', title);
    // elt.setAttribute('target', '_bank');
    elt.style.display = 'none';
    document.body.appendChild(elt);
    elt.click();
    document.body.removeChild(elt);
}

const isElementNotInViewport = function(el) {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
        rect.bottom <= 0
    );
};

const formatDateEn = (timeStamp) => {
    var date = new Date(timeStamp * 1000);
    var monthArr = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec");
    var suffix = new Array("st","nd","rd","th");

    var year = date.getFullYear();
    var month = monthArr[date.getMonth()];
    var ddate = date.getDate();

    if(ddate % 10 < 1 || ddate % 10 > 3) {
        ddate = ddate + suffix[3];
    }else if(ddate % 10 == 1) {
        ddate = ddate + suffix[0];
    } else if(ddate % 10 == 2) {
        ddate = ddate + suffix[1];
    }else {
        ddate = ddate + suffix[2];
    }
    return ddate + " "+ month + " " + year;
}

const formatDate = (timeStamp) => {
    // 时间戳为10位需*1000，时间戳为13位不需乘1000
    var date = new Date(timeStamp * 1000);
    var Y = date.getFullYear() + "/";
    var M =
        (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "/";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h = date.getHours() + ":";
    var m = date.getMinutes() + ":";
    var s = date.getSeconds();
    // return Y + M + D + h + m + s;
    return Y + M + D;
}

const urlConversion = (url) => {
    if (url.indexOf("https") < 0) {
        url = url.replace("http:", "https:");
    }
    return url
}

const getYouUri = (videoId) => {
    // return 'https://player.youku.com/embed/' + videoId + '?rel=0&autoplay=1'
    return 'https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1'
}
const getYouUrl = (videoId) => {
    // return 'https://v.youku.com/v_show/id_'+ videoId +'.html'
    return 'https://youtu.be/' + videoId;
}
export default
{
    encode,
    handleDownloadUri,
    isElementNotInViewport,
    formatDate,
    formatDateEn,
    urlConversion,
    getYouUri,
    getYouUrl
}